// ═══ A3 검차 상세(결과) `/main/s/requests/:id` (신고 371 · 앱 simple_result_screen.dart) ═══
// 본문은 requests/DetailBody.js — 데스크톱(≥1024) 2-pane 의 우측 패널과 **같은 컴포넌트**를 쓴다(§8 R2).
// 이 페이지는 ≤1023 에서만 마운트된다(routes.js RequestsOrDetail). 렌더 결과는 분리 전과 동일하다.
import React from 'react';
import { useParams } from 'react-router-dom';
import DetailBody from './requests/DetailBody';

function SimpleRequestDetail(props) {
  var id = useParams().id;
  return <DetailBody id={id} user={props.user} layout="page" />;
}

export default SimpleRequestDetail;
